import styled from "styled-components";

import Grid from "@material-ui/core/Grid";

import { easingSeconds } from "core/animation";
import { regular as regularFontWeight } from "core/fontStyles";
import breakpoints from "core/breakpoints";
import colors from "core/colors";

export const IconContainer = styled.div`
    svg {
        margin-bottom: 1.5rem; /* 24px */
        path {
            transition: all ${easingSeconds};
        }
    }
`;

export const Title = styled.p`
    font-size: 1.375rem; /* around 22.5px */
    line-height: 125%;
    margin-bottom: 1.5rem; /* 24px */
`;

export const Description = styled.p`
    width: 100%;
    margin-bottom: 1.5rem; /* 24px */
    font-size: 1.125rem; /* 18px */
    line-height: 1.813rem; /* 29px */
    color: ${colors.midnight};
    transition: all ${easingSeconds};
    ${regularFontWeight}
`;

export const LearnMore = styled.div`
    height: 2.5rem; /* 40px */
    transition: all ${easingSeconds};
    display: flex;
    align-items: center;
    justify-content: center;

    p {
        font-size: 1rem; /* 16px */
        line-height: 1.5rem; /* 24px */
        color: ${colors.fossil};
        display: inline;
        padding-bottom: 0.25rem; /* 4px */
        border-bottom: 1px solid ${colors.fossil};
        ${regularFontWeight}
    }
`;

export const LearnMoreIcons = styled.div`
    height: 2.5rem; /* 40px */
    width: 14.43rem; /* 230.88px */
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    svg {
        transition: all ${easingSeconds};
    }
`;

export const PromoBoxLink = styled.a`
    width: 100%;
    height: 100%;
    padding: 3rem 2rem; /* 48px 32px */
    text-align: center;
    border: 1px solid ${colors.concrete};
    transition: all ${easingSeconds};
    text-decoration: none;
    color: ${colors.midnight};

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-content: stretch;
    align-items: center;

    svg path,
    svg use,
    svg g,
    svg circle {
        fill: ${colors.midnight};
        fill-opacity: 1;
        transition: all ${easingSeconds};
    }

    &:hover {
        color: ${colors.snow};
        border-color: transparent;
        background-color: ${colors.pebble};

        img {
            opacity: 0.6;
        }

        svg path,
        svg use,
        svg g,
        svg circle {
            fill: ${colors.snow};
            fill-opacity: 1;
        }

        ${Description} {
            color: ${colors.snow};
        }

        ${LearnMore} p {
            color: ${colors.coin};
            border-color: ${colors.coin};
        }
    }
`;

export const PromoContainer = styled.div`
    /* Desktop: */
    @media (min-width: ${breakpoints.desktop.rem}) {
        /* adds padding on either side of grid for this breakpoint: */
        padding: 0 8.125rem; /* 0px 130px */
    }
`;

export const PromoGridItem = styled(Grid)`
    /* Tablet-only: */
    @media (min-width: ${breakpoints.tablet.rem}) and (max-width: ${breakpoints
            .beforeDesktop.rem}) {
        /* centers box on 2nd line for this breakpoint: */
        &:last-of-type {
            margin: 0 auto;
        }
    }
`;
